import MealPlannerDashboard from './MealPlannerDashboard';

export default MealPlannerDashboard;
